import { useEffect, useState } from "react";
import { deleteModel, getDataModelHeaders, getModelById } from "../../services/DataModelService";
import ViewMetricByModel from "../../components/configuration/ViewMetricByModel";
import { useDisclosure } from "@chakra-ui/react";
import showToast from "../../hooks/useCustomToast";
import { Header, ModelInfo } from "build-ts/metadata";
import { listMetrics } from "../../services/MetricService";

interface ViewMetricByModelContainerProps {
  onNavigateToGraph?: () => void;
}

const ViewMetricByModelContainer: React.FC<ViewMetricByModelContainerProps> = ({ onNavigateToGraph }) => {
  const [listModel, setListModel] = useState<Header[]>([]);
  const [modelInfo, setModelInfo] = useState<ModelInfo | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [metricFlag, setMetricFlag] = useState<boolean>(false);
  const [modelFlag, setModelFlag] = useState<boolean>(false); 
  const [deleteModelId, setDeleteModelId] = useState<string | null>(null);
  const [dependentMetricHeaders, setDependentMetricHeaders] = useState<Header[]>([]);
  const deleteModal = useDisclosure();
  const [modelsWithMissingKG, setModelsWithMissingKG] = useState<Set<string>>(new Set());
  const [metricList, setMetricList] = useState<Header[]>([]);

  // UseEffect hook to fetch model list when the component mounts
  useEffect(() => {
    const modelList = async () => {
      try {
        const data = await getDataModelHeaders(false /* Include only target models */);
        if (data) {
          setListModel(data);
        }
      } catch (error) {
        showToast("Error in REACT_APP_LIST_DATMODEL", "", "error");
      }
    };
    modelList();
  }, []);

  // fetch all metrics
  useEffect(() => {
    const fetchAllMetrics = async () => {
      const data = await listMetrics("");
      setMetricList(data);
    };
    fetchAllMetrics();
  }, []);

  const handleModelInfo = async(id: string) => {
      const data = await getModelById(id);
      if (data) {
        setModelInfo(data);
      }
      onOpen();
  };

  const handleCreateMetric = async(id: string) => {
       await handleModelInfo(id);
       setMetricFlag(true);
  };

  const handleUpdateModel = async(id: string) => {
      await handleModelInfo(id);
      setModelFlag(true);       
  };

  const handleDeleteModel = async(id: string) => {
      const response = await deleteModel(id);
      if (response.length > 0) {
        deleteModal.onOpen();
        setDependentMetricHeaders(response);
      } else {
        setListModel((prevList) => prevList.filter((model) => model.id !== id));
        setModelsWithMissingKG(prev => {
          const newSet = new Set(prev);
          newSet.delete(id);
          return newSet;
        });
      }
  };
  
  const closeMetric = () => {
      setMetricFlag(false);
      onClose();
  };

  // Function to handle the confirmation of deletion
  const confirmDelete = () => {
    if (deleteModelId) {
      handleDeleteModel(deleteModelId);
      setDeleteModelId(null); // Reset the deleteId after deletion
    }
    deleteModal.onClose();
  };

  // Function to handle the back button
  const onBack = () => {
    setModelFlag(false);
  };

  // Render the ViewMetric component
  return (
    <ViewMetricByModel 
      listModel={listModel} 
      metricList={metricList}
      handleCreateMetric={handleCreateMetric}
      modelInfo={modelInfo}
      isOpen={isOpen}
      metricFlag={metricFlag}
      closeMetric={closeMetric}
      handleUpdateModel={handleUpdateModel}
      modelFlag={modelFlag}
      deleteModal={deleteModal}
      confirmDelete={confirmDelete}
      setDeleteModelId={setDeleteModelId}
      dependentMetricHeaders={dependentMetricHeaders}
      setDependentMetricHeaders={setDependentMetricHeaders}
      modelsWithMissingKG={modelsWithMissingKG}
      onBack={onBack}
      onNavigateToGraph={onNavigateToGraph}
    />
  );
};

export default ViewMetricByModelContainer;
